import React, { useEffect, useState } from "react";
import { FaLayerGroup, FaUsers } from "react-icons/fa";
import { LuMessageSquarePlus } from "react-icons/lu";

import CreateMessageGroupForm from "./CreateMessageGroupForm";

export default function GroupMessages({ userId, onCounts }) {
  const [showGroupForm, setShowGroupForm] = useState(false);

  useEffect(() => {
    onCounts?.({ total: 0 });
  }, [onCounts]);

  return (
    <div className="space-y-4">
      <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/60">
        <div className="flex items-start gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300">
            <FaUsers />
          </div>

          <div>
            <p className="font-bold text-slate-950 dark:text-white">
              Messages groupés
            </p>

            <p className="mt-1 text-sm leading-6 text-slate-500 dark:text-slate-400">
              Envoie un message à un groupe de destinataires : bureau,
              enseignants, adhérents ou groupes configurés.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={() => setShowGroupForm((value) => !value)}
          className="mt-4 inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 text-sm font-bold text-white shadow-lg shadow-emerald-200/60 transition hover:-translate-y-0.5 hover:bg-emerald-700 dark:shadow-black/20 sm:w-auto"
        >
          {showGroupForm ? <FaLayerGroup /> : <LuMessageSquarePlus />}
          {showGroupForm ? "Masquer le formulaire" : "Nouveau message groupé"}
        </button>
      </div>

      {showGroupForm ? (
        <CreateMessageGroupForm
          userId={userId}
          onHide={() => setShowGroupForm(false)}
          onSent={() => setShowGroupForm(false)}
        />
      ) : (
        <div className="flex min-h-[220px] items-center justify-center rounded-[1.75rem] border border-dashed border-slate-300 bg-slate-50 p-6 text-center dark:border-slate-700 dark:bg-slate-950/50">
          <div>
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-emerald-600 shadow-md dark:bg-slate-900">
              <FaLayerGroup />
            </div>

            <h4 className="mt-4 text-lg font-bold text-slate-950 dark:text-white">
              Aucun formulaire ouvert
            </h4>

            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              Appuie sur “Nouveau message groupé” pour préparer ton envoi.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}